import Vue from 'vue'
import Router from 'vue-router'

import DesignRouter from './modules/design'
import AuthRouter from './modules/auth'
import SearchRouter from './modules/search'
import MyRouter from './modules/my'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(Router)
Vue.use(PerfectScrollbar)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/search/keyword-search',
    },
    AuthRouter,
    SearchRouter,
    MyRouter,
    DesignRouter,
  ]
})